import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 名設定ダイアログ
 */
class CommonItemTextSetting extends Dialog {
    targetItem: marietta.webcad.item.MonicaObject;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      // ターゲットの
      this.targetItem = marietta.webcad.WebCADGlobal.itemManager.currentItem;

      // ダイアログのコンテンツ生成
      const id: string = 'itemTextSettingDialog';
      let title: string = '汎用アイテム名の設定';

      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Item Name Setting'; break;
        default: title = '汎用アイテム名の設定'; break;
      }

      let contents: string = '<div class="dialogItemTextSetting">\n';
      contents += '<table>\n';
      contents += '<tbody>\n';
      contents += '<tr>\n';
      contents += '<td><label><span class="jp">オブジェクト名</span><span class="en">Object Name</span></label></td>\n';
      contents += '<td><input type="text" id="input_itemText" maxlength="10"><span class="jp">（最大10文字）</span><span class="en">(Max 10 characters)</span></td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '</div>';
      let footer: string = '<button id="btnDoneItemTextSetting"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
      footer += '<button id="btnClose"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

      this.createDialog(id, title, contents, footer);

      (<HTMLInputElement>document.getElementById('input_itemText')).value = this.targetItem.itemInfo.text;

      // イベント設定
      (<HTMLButtonElement>document.getElementById('btnDoneItemTextSetting')).addEventListener('click', this.updateItemText);

      (<HTMLInputElement>document.getElementById('input_itemText')).addEventListener('keydown', this.restrictMaxLength);
      (<HTMLInputElement>document.getElementById('input_itemText')).addEventListener('keyup', this.restrictMaxLength);
      (<HTMLInputElement>document.getElementById('input_itemText')).addEventListener('blur', this.restrictMaxLength);

      (<HTMLButtonElement>document.getElementById('btnClose')).addEventListener('click', () => {
        marietta.webcad.WebCADGlobal.removeDialog();
      });
    }

    /**
     * 名前設定の反映
     */
     updateItemText = () => {
       let itemName = (<HTMLInputElement>document.getElementById('input_itemText')).value as string;
       // 入力チェック
       if (!itemName || itemName === '') {
         marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ALERT_INPUT_ITEMNAME'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
         return;
       }
       itemName = marietta.webcad.util.EscapeSymbol.escapeSymbol(itemName);
       // 部屋名称を設定
       this.targetItem.itemInfo.text = itemName;
       // ヒストリ
       marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
       // ダイアログを閉じる
       this.close();
     }

    /**
     * 部屋名の文字数制限
     */
    restrictMaxLength = (e: Event) => {
      const maxLen: number = 10;
      const $target: HTMLInputElement = <HTMLInputElement>e.currentTarget;
      // 文字数チェック
      const len: number = ($target.value as string).length;
      let str: string;
      if (len <= maxLen) return;
      // 入力制限
      str = $target.value as string;
      str = str.substring(0, maxLen);
      $target.value = str;
    }
}
export default CommonItemTextSetting;
